<!-- 非递归渲染侧边栏菜单 license by http://eleadmin.com -->
<template>
  <el-menu
    :mode="mode"
    :class="themeClass"
    :collapse="collapse"
    :unique-opened="uniqueOpened"
    :default-active="defaultActive"
    :default-openeds="defaultOpeneds"
    :collapse-transition="collapseTransition"
  >
    <template v-for="m1 in data">
      <template v-if="!m1.meta.hide">
        <el-submenu
          v-if="haveChildren(m1)"
          :key="m1.path"
          :index="m1.path"
          :popper-class="firstPopClass || popClass"
          :popper-append-to-body="true"
        >
          <template slot="title">
            <i v-if="m1.meta.icon" :class="m1.meta.icon"></i>
            <span>{{ m1.meta.title }}</span>
          </template>
          <template v-for="m2 in m1.children">
            <template v-if="!m2.meta.hide">
              <el-submenu
                v-if="haveChildren(m2)"
                :key="m2.path"
                :index="m2.path"
                :popper-class="popClass"
                :popper-append-to-body="true"
              >
                <template slot="title">
                  <i v-if="m2.meta.icon" :class="m2.meta.icon"></i>
                  <span>{{ m2.meta.title }}</span>
                </template>
                <template v-for="m3 in m2.children">
                  <template v-if="!m3.meta.hide">
                    <el-submenu
                      v-if="haveChildren(m3)"
                      :key="m3.path"
                      :index="m3.path"
                      :popper-class="popClass"
                      :popper-append-to-body="true"
                    >
                      <template slot="title">
                        <i v-if="m3.meta.icon" :class="m3.meta.icon"></i>
                        <span>{{ m3.meta.title }}</span>
                      </template>
                      <template v-for="m4 in m3.children">
                        <template v-if="!m4.meta.hide">
                          <el-submenu
                            v-if="haveChildren(m4)"
                            :key="m4.path"
                            :index="m4.path"
                            :popper-class="popClass"
                            :popper-append-to-body="true"
                          >
                            <template slot="title">
                              <i v-if="m4.meta.icon" :class="m4.meta.icon"></i>
                              <span>{{ m4.meta.title }}</span>
                            </template>
                            <template v-for="m5 in m4.children">
                              <template v-if="!m5.meta.hide">
                                <el-submenu
                                  v-if="haveChildren(m5)"
                                  :key="m5.path"
                                  :index="m5.path"
                                  :popper-class="popClass"
                                  :popper-append-to-body="true"
                                >
                                  <template slot="title">
                                    <i
                                      v-if="m5.meta.icon"
                                      :class="m5.meta.icon"
                                    ></i>
                                    <span>{{ m5.meta.title }}</span>
                                  </template>
                                  <template v-for="m6 in m5.children">
                                    <template v-if="!m6.meta.hide">
                                      <el-submenu
                                        v-if="haveChildren(m6)"
                                        :key="m6.path"
                                        :index="m6.path"
                                        :popper-class="popClass"
                                        :popper-append-to-body="true"
                                      >
                                        <template slot="title">
                                          <i
                                            v-if="m6.meta.icon"
                                            :class="m6.meta.icon"
                                          ></i>
                                          <span>{{ m6.meta.title }}</span>
                                        </template>
                                        <template v-for="m7 in m6.children">
                                          <template v-if="!m7.meta.hide">
                                            <el-submenu
                                              v-if="haveChildren(m7)"
                                              :key="m7.path"
                                              :index="m7.path"
                                              :popper-class="popClass"
                                              :popper-append-to-body="true"
                                            >
                                              <template slot="title">
                                                <i
                                                  v-if="m7.meta.icon"
                                                  :class="m7.meta.icon"
                                                ></i>
                                                <span>{{ m7.meta.title }}</span>
                                              </template>
                                              <template
                                                v-for="m8 in m7.children"
                                              >
                                                <el-menu-item
                                                  v-if="!m8.meta.hide"
                                                  :key="m8.path"
                                                  :index="m8.path"
                                                >
                                                  <a
                                                    v-if="isUrl(m8)"
                                                    :href="m8.path"
                                                    target="_blank"
                                                    @click.stop=""
                                                  >
                                                    <i
                                                      v-if="m8.meta.icon"
                                                      :class="m8.meta.icon"
                                                    ></i>
                                                    <span>{{
                                                      m8.meta.title
                                                    }}</span>
                                                  </a>
                                                  <router-link
                                                    v-else
                                                    :to="m8.path"
                                                  >
                                                    <i
                                                      v-if="m8.meta.icon"
                                                      :class="m8.meta.icon"
                                                    ></i>
                                                    <span>{{
                                                      m8.meta.title
                                                    }}</span>
                                                  </router-link>
                                                </el-menu-item>
                                              </template>
                                            </el-submenu>
                                            <el-menu-item
                                              v-else
                                              :key="m7.path"
                                              :index="m7.path"
                                            >
                                              <a
                                                v-if="isUrl(m7)"
                                                :href="m7.path"
                                                target="_blank"
                                                @click.stop=""
                                              >
                                                <i
                                                  v-if="m7.meta.icon"
                                                  :class="m7.meta.icon"
                                                ></i>
                                                <span>{{ m7.meta.title }}</span>
                                              </a>
                                              <router-link v-else :to="m7.path">
                                                <i
                                                  v-if="m7.meta.icon"
                                                  :class="m7.meta.icon"
                                                ></i>
                                                <span>{{ m7.meta.title }}</span>
                                              </router-link>
                                            </el-menu-item>
                                          </template>
                                        </template>
                                      </el-submenu>
                                      <el-menu-item
                                        v-else
                                        :key="m6.path"
                                        :index="m6.path"
                                      >
                                        <a
                                          v-if="isUrl(m6)"
                                          :href="m6.path"
                                          target="_blank"
                                          @click.stop=""
                                        >
                                          <i
                                            v-if="m6.meta.icon"
                                            :class="m6.meta.icon"
                                          ></i>
                                          <span>{{ m6.meta.title }}</span>
                                        </a>
                                        <router-link v-else :to="m6.path">
                                          <i
                                            v-if="m6.meta.icon"
                                            :class="m6.meta.icon"
                                          ></i>
                                          <span>{{ m6.meta.title }}</span>
                                        </router-link>
                                      </el-menu-item>
                                    </template>
                                  </template>
                                </el-submenu>
                                <el-menu-item
                                  v-else
                                  :key="m5.path"
                                  :index="m5.path"
                                >
                                  <a
                                    v-if="isUrl(m5)"
                                    :href="m5.path"
                                    target="_blank"
                                    @click.stop=""
                                  >
                                    <i
                                      v-if="m5.meta.icon"
                                      :class="m5.meta.icon"
                                    ></i>
                                    <span>{{ m5.meta.title }}</span>
                                  </a>
                                  <router-link v-else :to="m5.path">
                                    <i
                                      v-if="m5.meta.icon"
                                      :class="m5.meta.icon"
                                    ></i>
                                    <span>{{ m5.meta.title }}</span>
                                  </router-link>
                                </el-menu-item>
                              </template>
                            </template>
                          </el-submenu>
                          <el-menu-item v-else :key="m4.path" :index="m4.path">
                            <a
                              v-if="isUrl(m4)"
                              :href="m4.path"
                              target="_blank"
                              @click.stop=""
                            >
                              <i v-if="m4.meta.icon" :class="m4.meta.icon"></i>
                              <span>{{ m4.meta.title }}</span>
                            </a>
                            <router-link v-else :to="m4.path">
                              <i v-if="m4.meta.icon" :class="m4.meta.icon"></i>
                              <span>{{ m4.meta.title }}</span>
                            </router-link>
                          </el-menu-item>
                        </template>
                      </template>
                    </el-submenu>
                    <el-menu-item v-else :key="m3.path" :index="m3.path">
                      <a
                        v-if="isUrl(m3)"
                        :href="m3.path"
                        target="_blank"
                        @click.stop=""
                      >
                        <i v-if="m3.meta.icon" :class="m3.meta.icon"></i>
                        <span>{{ m3.meta.title }}</span>
                      </a>
                      <router-link v-else :to="m3.path">
                        <i v-if="m3.meta.icon" :class="m3.meta.icon"></i>
                        <span>{{ m3.meta.title }}</span>
                      </router-link>
                    </el-menu-item>
                  </template>
                </template>
              </el-submenu>
              <el-menu-item v-else :key="m2.path" :index="m2.path">
                <a
                  v-if="isUrl(m2)"
                  :href="m2.path"
                  target="_blank"
                  @click.stop=""
                >
                  <i v-if="m2.meta.icon" :class="m2.meta.icon"></i>
                  <span>{{ m2.meta.title }}</span>
                </a>
                <router-link v-else :to="m2.path">
                  <i v-if="m2.meta.icon" :class="m2.meta.icon"></i>
                  <span>{{ m2.meta.title }}</span>
                </router-link>
              </el-menu-item>
            </template>
          </template>
        </el-submenu>
        <el-menu-item v-else :key="m1.path" :index="m1.path">
          <el-tooltip
            placement="right"
            :content="m1.meta.title"
            :disabled="tooltipDisabled || !collapse"
          >
            <a v-if="isUrl(m1)" :href="m1.path" target="_blank" @click.stop="">
              <i v-if="m1.meta.icon" :class="m1.meta.icon"></i>
              <span>{{ m1.meta.title }}</span>
            </a>
            <router-link v-else :to="m1.path">
              <i v-if="m1.meta.icon" :class="m1.meta.icon"></i>
              <span>{{ m1.meta.title }}</span>
            </router-link>
          </el-tooltip>
        </el-menu-item>
      </template>
    </template>
  </el-menu>
</template>

<script>
  import { isUrl } from '../../../utils/index.js';

  export default {
    name: 'EleProSidebarMenus',
    props: {
      // 菜单数据
      data: Array,
      // 导航模式
      mode: String,
      // pop菜单class
      popClass: String,
      // 是否折叠
      collapse: Boolean,
      // 选中菜单
      defaultActive: String,
      // 折叠是否动画效果
      collapseTransition: Boolean,
      // 是否互斥展开
      uniqueOpened: Boolean,
      // 侧边栏默认展开的子菜单
      defaultOpeneds: Array,
      // 主题class
      themeClass: String,
      // 一级pop菜单class
      firstPopClass: String,
      // 是否禁用tooltip
      tooltipDisabled: Boolean
    },
    methods: {
      /* 是否有子级 */
      haveChildren(item) {
        return !!(
          item.children && item.children.filter((d) => !d.meta.hide).length
        );
      },
      /* 是否是网址 */
      isUrl(item) {
        return isUrl(item.path);
      }
    }
  };
</script>
